import React from 'react';

import JobBoardScene from 'views/scenes/job_board/JobBoard';

const JobBoard = (props) => {
  return (
    <>
      <JobBoardScene

      />
    </>
  );
};

JobBoard.propTypes = {
};

export default React.memo(JobBoard);

